export default function ErrorIcon({ className, color = '#FF2975' }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M45.3972 23.3972C45.3972 11.2514 35.5431 1.39723 23.3972 1.39723C11.2514 1.39723 1.39723 11.2514 1.39723 23.3972C1.39723 35.5431 11.2514 45.3972 23.3972 45.3972C35.5431 45.3972 45.3972 35.5431 45.3972 23.3972Z"
        stroke={color}
        strokeWidth="2.79446"
        strokeMiterlimit="10"
      />
      <path
        d="M22.7413 13.0885L23.399 27.062L24.0556 13.0885C24.0596 12.9992 24.0454 12.91 24.0138 12.8263C23.9822 12.7427 23.9339 12.6663 23.8718 12.602C23.8097 12.5376 23.7352 12.4866 23.6527 12.4521C23.5702 12.4175 23.4815 12.4002 23.3921 12.401C23.3038 12.4019 23.2165 12.4205 23.1355 12.4558C23.0545 12.4911 22.9814 12.5424 22.9207 12.6065C22.8599 12.6707 22.8128 12.7465 22.7819 12.8293C22.7511 12.9121 22.7373 13.0003 22.7413 13.0885Z"
        stroke={color}
        strokeWidth="2.79446"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3974 36.2192C22.9441 36.2192 22.5011 36.0848 22.1242 35.833C21.7474 35.5812 21.4536 35.2233 21.2802 34.8045C21.1067 34.3858 21.0613 33.925 21.1498 33.4804C21.2382 33.0359 21.4564 32.6276 21.7769 32.3071C22.0974 31.9866 22.5058 31.7683 22.9503 31.6799C23.3949 31.5915 23.8556 31.6368 24.2744 31.8103C24.6931 31.9837 25.051 32.2775 25.3028 32.6543C25.5547 33.0312 25.6891 33.4743 25.6891 33.9275C25.6891 34.5353 25.4476 35.1182 25.0179 35.548C24.5881 35.9777 24.0052 36.2192 23.3974 36.2192Z"
        fill={color}
      />
    </svg>
  );
}




